<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Business Functions</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all the Business Functions.</p>
        </div>
        <div v-if="!isPilot" class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="openQuestionSectionModal(null)" type="button" class="block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
            Add Business Function
          </button>
        </div>
      </div>
      <SearchComponent @setSearchText="setSearchText"/>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">

          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Title</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Website</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Business Key</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Network</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Regulatory permissions</th>
                <th scope="col" class="px-3 py-1 text-right text-sm font-semibold text-gray-900">Options</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.id }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.title }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.website }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.key }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.network_name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.regulatory_permissions ? item.regulatory_permissions.split(' ').slice(0, 4).join(" ") + '...' : ''}}</td>

                <td class="py-1 pl-3 text-sm font-medium sm:pr-0">
                  <div class="flex items-center justify-end gap-x-0">
                    <RouterLink :to="{ name: 'QuestionSectionShow', params: { id: item.id } }" class="network-button-color hover:text-gray-900">
                      <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </RouterLink>
                    <button v-if="!isPilot" @click="openQuestionSectionModal(item.id)" type="button" class="network-button-color hover:text-gray-900">
                      <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                    <button v-if="!isPilot" @click="destroy(item.id)" type="button" class="network-button-color hover:text-gray-900">
                      <TrashIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {EyeIcon, PencilSquareIcon, TrashIcon} from "@heroicons/vue/20/solid";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import QuestionSectionCreateEditFormComponent from "./QuestionSectionCreateEditFormComponent.vue";
import SearchComponent from "../SearchComponent.vue";

export default {
  name: "QuestionSectionIndexComponent",
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null,
      searchText: null,
    }
  },
  components: {
    SearchComponent,
    PaginationComponent,
    EyeIcon,
    PencilSquareIcon,
    TrashIcon,
  },
  computed: {
    isPilot() {
      return this.$store.state.onlyPilotNetwork;
    },
  },
  watch: {
    searchText: {
      handler(newValue, oldValue) {
        this.getItems();
      },
      deep: true
    },
  },
  methods: {
    setSearchText(value) {
      this.searchText = value;
    },
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/question-section/index?page=${page}`, {params: {'search_text': this.searchText}}).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    destroy(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/question-section/destroy/${id}`).then((res) => {
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          this.getItems();
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
    openQuestionSectionModal(questionSectionId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: QuestionSectionCreateEditFormComponent,
            attrs: {
              questionSectionId: questionSectionId,
              onReloadIndex() {
                self.getItems();
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
  },
  created() {
    this.getItems();
  },
}
</script>